export const ANALYTICS_SCREEN_MANAGE_APP_VERSION_PUBLISH = 'manageAppVersionPublishScreen';
export const ANALYTICS_APP_VERSION_UPLOAD_APP_ARTIFACT = 'appVersionUploadAppArtifact';
export const ANALYTICS_APP_VERSION_SUBMIT_APP_ARTIFACT_URL = 'appVersionSubmitAppArtifactURL';
export const ANALYTICS_APP_VERSION_SUBMIT_APP_ARTIFACT_URL_VALIDATED = 'appVersionAppArtifactURLValidated';
export const ANALYTICS_APP_VERSION_SUBMIT_PRIVATE_VERSION = 'submitPrivateAppVersion';
export const ANALYTICS_APP_VERSION_MAKE_VERSION_PUBLIC = 'submitMakeAppVersionPublic';
export const ANALYTICS_APP_VERSION_PUBLISH_VIEW = 'appVersionPublishView';